<ng-container *ngIf="bindValue">
  <ng-select
    #ngSelect
    [multiple]="true"
    [items]="items.model$ | async"
    [closeOnSelect]="false"
    [placeholder]="placeholder"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [loading]="loading"
    (blur)="onTouched()"
    (ngModelChange)="change($event)"
    [(ngModel)]="selected"
    clearAllText="Clear"
    class="form-control">
    <ng-template ng-header-tmp>
      <div class="d-flex">
        <button (click)="select()" class="btn btn-sm btn-primary text-nowrap">
          Select all
        </button>
        <button
          (click)="unselect()"
          class="btn btn-sm btn-primary ms-1 text-nowrap">
          Unselect all
        </button>
      </div>
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items">
      <div class="ng-value" *ngFor="let m of $any(items | slice : 0 : 1)">
        {{ m[bindLabel] }}
      </div>
      <div class="ng-value" *ngIf="items.length > 1">
        <span class="ng-value-label">+{{ items.length - 1 }} </span>
      </div>
    </ng-template>

    <ng-template
      ng-option-tmp
      let-item="item"
      let-item$="item$"
      let-index="index">
      <div class="form-check">
        <label class="form-check-label" [for]="control">
          {{ item[bindLabel] | titlecase }}
          <input
            class="form-check-input"
            id="item-{{ control }}-{{ index }}"
            type="checkbox"
            [(ngModel)]="item$.selected"
            [ngModelOptions]="{ standalone: true }" />
        </label>
      </div>
    </ng-template>
  </ng-select>
</ng-container>

<ng-container *ngIf="!bindValue">
  <ng-select
    #ngSelect
    [multiple]="true"
    [items]="items.model$ | async"
    [closeOnSelect]="false"
    [placeholder]="placeholder"
    [bindLabel]="bindLabel"
    [loading]="loading"
    (blur)="onTouched()"
    (ngModelChange)="change($event)"
    [(ngModel)]="selected"
    clearAllText="Clear"
    class="form-control">
    <ng-template ng-header-tmp>
      <div class="d-flex">
        <button (click)="select()" class="btn btn-sm btn-primary text-nowrap">
          Select all
        </button>
        <button
          (click)="unselect()"
          class="btn btn-sm btn-primary ms-1 text-nowrap">
          Unselect all
        </button>
      </div>
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items">
      <div class="ng-value" *ngFor="let m of $any(items | slice : 0 : 1)">
        {{ m[bindLabel] }}
      </div>
      <div class="ng-value" *ngIf="items.length > 1">
        <span class="ng-value-label">+{{ items.length - 1 }} </span>
      </div>
    </ng-template>

    <ng-template
      ng-option-tmp
      let-item="item"
      let-item$="item$"
      let-index="index">
      <div class="form-check">
        <label class="form-check-label" [for]="control">
          {{ item[bindLabel] | titlecase }}
          <input
            class="form-check-input"
            id="item-{{ control }}-{{ index }}"
            type="checkbox"
            [(ngModel)]="item$.selected"
            [ngModelOptions]="{ standalone: true }" />
        </label>
      </div>
    </ng-template>
  </ng-select>
</ng-container>
